// extracted by mini-css-extract-plugin
var _1 = "_discountsTableStyles-module__button-container";
var _2 = "_discountsTableStyles-module__danger";
var _3 = "_discountsTableStyles-module__title";
export { _1 as "button-container", _2 as "danger", _3 as "title" }
